<template>
	<div class="pagination">
		<aside class="pagination__container">
			<nav class="pagination__links-wrap">
				<a
					href="#"
					class="pagination__page-link"
					
					v-for="index in parseInt(totalpage)"
					:key="index"
					
					v-bind:class="[ currpage == index ? 'active' : '']"
					v-on:click="gotoPage(index)"
					
					>{{ index }}</a>
			</nav>
			<!-- <form class="date-selector">
				<label for="" class="date-selector__label">Date Selector</label>
				<input type="date" class="date-selector__date-input" />
			</form> -->
		</aside>
	</div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
	name: "pagination",
	components: {},
	data () {
		return {
			currpage: 1,
		}
	},
	props: {
		totalpage: Number,
		pageno: Number
	},
	methods: {
	
		
	
		gotoPage: function(pageno) {
		
			//this.$store.getters.cancelItemRequest;
			
			this.$store.commit('updatePageNo', pageno);
			this.$store.dispatch('getData')
			
			this.currpage = pageno;
			
			this.$router.push({ path: `/listOrders/${pageno}` })
		}
	}, 
	mounted() {
		this.currpage = parseInt(this.pageno);
	}
	
});
</script>

<style lang="scss" scoped>
.pagination {
	&__container {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	&__links-wrap {
		margin: 0 32px;
		border-radius: 5px;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}

	&__page-link {
		border: 1px solid $border-color;
		display: inline-block;
		text-align: center;
		padding: 2px 0;
		margin: 1px 1px;
		width: 34px;
		background-color: $color1;
		font-weight: 500;
		font-size: 14px;

		&:hover {
			background-color: $color2;
			color: $color1;
		}
		

	}
}

.active {
		background-color: $color2;
		color: $color1;
}

.date-selector {
	padding-left: 20px;

	&__label {
		margin-right: 15px;
		font-weight: 600;
		font-size: 12px;
	}

	&__date-input {
		box-shadow: 1px 1px 1px $border-color;
		padding: 3px 5px 3px 10px;
		border-radius: 5px;
		border: none;
	}
}
</style>